import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './ForceDisableCheckbox.module.scss';

interface IProps {
	toggleForceDisable: () => void;
	forceDisable: boolean;
	isDisabled: boolean;
}

export const ForceDisableCheckbox: React.FC<IProps> = React.memo(({ toggleForceDisable, forceDisable, isDisabled }) => {
	return (
		<Form.Item className={style.container} name="forceDisable" data-test="ForceDisableCheckbox">
			<Checkbox onChange={toggleForceDisable} checked={forceDisable} disabled={isDisabled}>
				<Text translationNameSpace="form" translationKey="isForceDisabledLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
